import { Maybe } from '../../../../utils/maybe';
import { createShowCommentQueryParams } from '../../components/Comment';
import { Item } from './useExpenseTableRenderSettings';

type QueryParams = Record<string, string>;

interface BuildExpenseQueryParamsInput {
  item: Maybe<Item>;
  expandedGroups: Set<string>;
  currentQueryParams?: QueryParams;
}

export const buildExpandedParam = (
  expandedGroups: Set<string>,
): QueryParams => {
  return expandedGroups.size > 0
    ? { expanded: Array.from(expandedGroups).join(',') }
    : {};
};

export const buildCommentParams = (item: Maybe<Item>): QueryParams => {
  if (!item?.id || !item.showComments) return {};
  return createShowCommentQueryParams({ recordId: item.id });
};

export const buildItemsParam = (item: Maybe<Item>): QueryParams => {
  return item?.showItems ? { showItems: 'true' } : {};
};

export const filterCurrentParams = (
  currentParams: QueryParams,
  item: Maybe<Item>,
): QueryParams => {
  const filtered = { ...currentParams };

  if (!item?.showComments) {
    delete filtered.showComments;
    delete filtered.recordId;
    delete filtered.recordType;
  }

  if (!item?.showItems) {
    delete filtered.showItems;
  }

  return filtered;
};

export const buildExpenseQueryParams = ({
  item,
  expandedGroups,
  currentQueryParams = {},
}: BuildExpenseQueryParamsInput): QueryParams => {
  const filteredParams = { ...currentQueryParams };

  if (expandedGroups.size === 0) {
    delete filteredParams.expanded;
  }

  if (!item?.id) {
    return expandedGroups.size > 0
      ? { ...filteredParams, ...buildExpandedParam(expandedGroups) }
      : filteredParams;
  }

  const filteredCurrentParams = filterCurrentParams(filteredParams, item);
  const commentParams = buildCommentParams(item);
  const itemsParams = buildItemsParam(item);
  const expandedParam = buildExpandedParam(expandedGroups);

  return {
    ...filteredCurrentParams,
    ...commentParams,
    ...itemsParams,
    ...expandedParam,
  };
};
